import { Activity, Brain, Heart, Moon } from 'lucide-react';
import { MetricConfig } from './types';
import { METRIC_COLORS } from './constants';
import { HealthMetrics } from '../../../types/health';

export function getMetricConfigs(metrics: HealthMetrics): MetricConfig[] {
  return [
    {
      label: 'Recovery',
      value: metrics.recovery,
      unit: '%',
      icon: {
        component: Heart,
        props: { className: "w-4 h-4" }
      },
      tab: 'recovery',
      position: 'left-top',
      colors: METRIC_COLORS.recovery
    },
    {
      label: 'HRV',
      value: metrics.hrv.current,
      unit: 'ms',
      icon: {
        component: Brain,
        props: { className: "w-4 h-4" }
      },
      tab: 'hrv',
      position: 'left-bottom',
      colors: METRIC_COLORS.hrv
    },
    {
      label: 'Strain',
      value: metrics.strain.current,
      icon: {
        component: Activity,
        props: { className: "w-4 h-4" }
      },
      tab: 'strain',
      position: 'right-top',
      colors: METRIC_COLORS.strain
    },
    {
      label: 'Sleep',
      value: metrics.sleep.score,
      unit: '%',
      icon: {
        component: Moon,
        props: { className: "w-4 h-4" }
      },
      tab: 'sleep',
      position: 'right-bottom',
      colors: METRIC_COLORS.sleep
    }
  ];
}